export const deliveryTypeOptionModel = {
  id: "",
  description: "",
  price: 0,
};
